import general from './general.json';
import questionnaire from './questionnaire.json';
import eVisits from './e-visits.json';
import lifeId from './life-id.json';
import ui from './ui.json';
import kyc from './kyc.json';
import reservationForm from './reservation-form.json';
import twilio from './twilio.json';
import provider from './provider.json';
import routes from './routes.json';

export default {
  ...general,
  ...questionnaire,
  ...eVisits,
  ...ui,
  ...kyc,
  ...lifeId,
  ...reservationForm,
  ...twilio,
  ...provider,
  ...routes,
};
